import { AHIcon, Box, TouchableBox, useLayoutContext } from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";

type ZoomButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  iconType: "add" | "minus";
};

const ZoomButton = ({
  onPress,
  disabled = false,
  iconType,
}: ZoomButtonProps) => {
  return (
    <TouchableBox space="small" onPress={onPress} disabled={disabled}>
      <Box
        color="lightText"
        shadow="weak"
        space="small"
        cornerRadius="large"
        style={{
          opacity: disabled ? 0.4 : 0.8,
        }}
      >
        <AHIcon type={iconType} />
      </Box>
    </TouchableBox>
  );
};

type ZoomControlsProps = {
  zoomLevel: number;
  minZoom: number;
  maxZoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export const ZoomControls = ({
  zoomLevel,
  minZoom,
  maxZoom,
  onZoomIn,
  onZoomOut,
}: ZoomControlsProps) => {
  const layout = useLayoutContext();
  const inset = useSafeAreaInsets();

  return (
    <Box
      style={{
        position: "absolute",
        right: layout.space.small,
        bottom: layout.space.small + inset.bottom,
        flexDirection: "column",
      }}
    >
      <ZoomButton
        onPress={onZoomIn}
        disabled={zoomLevel >= maxZoom}
        iconType="add"
      />
      <ZoomButton
        onPress={onZoomOut}
        disabled={zoomLevel <= minZoom}
        iconType="minus"
      />
    </Box>
  );
};
